<template>
  <div class="home" ref="page">
    <!-- Hero Section -->
    <section class="hero-full">
      <div class="hero-bg">
        <img src="@/assets/images/home-hero-bg.jpg" alt="main" />
      </div>
      <div class="hero-overlay"></div>
      <div class="container hero-content">
        <div class="hero-badge animate-slide-up">Simple is ASTOC</div>
        <h1 class="animate-slide-up delay-1">What does the <br/><span>Customer Value?</span></h1>
        <p class="animate-slide-up delay-2">
          아스톡의 미션은 소비자가 공급받는 서비스의 가치입니다. <br/>
          매출과 실적에 앞서 고객이 실제로 누리는 가치를 먼저 생각하며,<br/>
          사회적 가치를 창출하는 기업이 되겠습니다. (Social Mission &amp; Value Creation)
        </p>
        <div class="hero-btns animate-slide-up delay-3">
          <a href="http://www.astoc.kr" target="_blank" rel="noopener noreferrer" class="btn btn-ghost">🦟 해충방제</a>
          <router-link to="/business" class="btn btn-red">BUSINESS AREAS</router-link>
          <router-link to="/about" class="btn btn-ghost">ABOUT ASTOC</router-link>
        </div>
      </div>
      <div class="scroll-indicator">SCROLL DOWN</div>
    </section>

    <!-- 사업 역량 섹션 -->
    <section class="competency-section bg-light animated-section">
      <div class="container">
        <SectionHeader badge="CORE COMPETENCY" title="최상의 사업 파트너, 아스톡" subtitle="아스톡은 단순 관리를 넘어, 자산 가치를 높이는 파트너입니다." />
        <div class="competency-grid">
          <div class="comp-card" v-for="item in coreCompetencies" :key="item.title">
            <div class="comp-icon">{{ item.icon }}</div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 아스톡 통합 운영 서비스 범위 -->
    <section class="service-grid-bg bg-light animated-section">
      <div class="container">
        <SectionHeader badge="INTEGRATED SERVICES" title="아스톡 통합 운영 서비스 범위" subtitle="시설관리부터 해충방제까지, 부동산 운영에 필요한 모든 서비스를 한 번에 제공합니다." />
        <div class="s-grid">
          <a
            v-for="s in mainServices"
            :key="s.id"
            :href="s.link || undefined"
            :target="s.link ? '_blank' : '_self'"
            :rel="s.link ? 'noopener noreferrer' : undefined"
            class="s-card-link"
          >
            <div class="s-card" :class="{ 'has-link': s.link }">
              <span v-if="s.link" class="s-link-badge">바로가기 →</span>
              <div class="s-icon">{{ s.icon }}</div>
              <h3>{{ s.title }}</h3>
              <p>{{ s.desc }}</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue';
import { coreCompetencies } from '../data/homeData.js';
import { mainServices } from '../data/businessData.js';
 
export default {
  name: 'HomeView',
  components: { SectionHeader },
  data() {
    return {
      coreCompetencies,
      mainServices,
    };
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    this.$refs.page.querySelectorAll('.animated-section').forEach(section => {
      observer.observe(section);
    });
  }
}
</script>

<style scoped>
/* Hero Styling */
.hero-full {
  height: calc(100vh - var(--header-height));
  position: relative;
  overflow: hidden;
  display: flex; align-items: center; color: white;
}
.hero-bg { position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; }
.hero-bg img { width: 100%; height: 100%; object-fit: cover; transform: scale(1.1); filter: brightness(0.8); }
.hero-overlay {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(135deg, rgba(1, 58, 113, 0.9) 0%, rgba(1, 58, 113, 0.3) 100%);
  z-index: 2;
}
.hero-content { position: relative; z-index: 10; max-width: 1000px; }

.hero-badge {
  display: inline-block; background: var(--primary-red); color: white;
  padding: 8px 20px; border-radius: 50px; font-weight: 800; font-size: 14px;
  margin-bottom: 35px; letter-spacing: 2px;
}
.hero-content h1 { font-size: 85px; font-weight: 900; line-height: 1.1; margin-bottom: 40px; letter-spacing: -2px; }
.hero-content h1 span { color: var(--primary-red); }
.hero-content p { font-size: 22px; font-weight: 300; opacity: 0.8; margin-bottom: 60px; line-height: 1.6; }

.hero-btns { display: flex; gap: 20px; }
.btn { padding: 20px 45px; border-radius: 4px; font-size: 16px; font-weight: 800; text-decoration: none; transition: 0.4s; }
.btn-red { background: var(--primary-red); color: white; }
.btn-red:hover { background: #b3241b; transform: translateY(-5px); box-shadow: 0 15px 30px rgba(217, 48, 37, 0.3); }
.btn-ghost { border: 2px solid white; color: white; }
.btn-ghost:hover { background: white; color: var(--primary-blue); }

.scroll-indicator {
  position: absolute; bottom: 50px; left: 40px; z-index: 10;
  writing-mode: vertical-lr; font-size: 12px; font-weight: 700; letter-spacing: 4px;
}

.competency-section { padding: 150px 0; }
.competency-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; }
.comp-card {
  background: white;
  border-radius: 20px;
  text-align: center;
  transition: all 0.4s ease;
  box-shadow: 0 10px 30px rgba(78, 9, 9, 0.05);
  padding: 50px 40px;
  border-top: 5px solid var(--primary-red); /* 카드 상단에 빨간색 라인 추가 */
}
.comp-card:hover {
  transform: translateY(-10px);
  background-color: var(--primary-blue);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}
.comp-icon { font-size: 4rem; margin-bottom: 30px; }
.comp-card h3 { font-size: 22px; color: var(--primary-blue); margin-bottom: 20px; }
.comp-card p { color: var(--text-sub); line-height: 1.7; }

/* 통합 운영 서비스 범위 */
.service-grid-bg { padding: 150px 0; }
.s-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 30px; margin-top: 60px; }
.s-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  position: relative;
}
.s-card {
  position: relative;
  padding: 40px 30px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  text-align: center;
  transition: 0.3s;
  border-top: 5px solid var(--primary-red);
  height: 100%;
  box-sizing: border-box;
}
.s-icon, .s-card h3, .s-card p { transition: color 0.3s ease; }
.s-icon { font-size: 3.5rem; margin-bottom: 10px; }
.s-card h3 { font-size: 22px; color: var(--primary-blue); margin-bottom: 15px; }
.s-card p { font-size: 15px; line-height: 1.6; color: var(--text-sub); }

/* 링크가 걸린 카드(해충방제 등) 강조 */
.s-card.has-link {
  border-top-color: #16a34a;
  box-shadow: 0 12px 30px rgba(22, 163, 74, 0.18);
}
.s-link-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  background: #16a34a;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 50px;
  letter-spacing: 0.5px;
}
.s-card-link:hover .s-card {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}
.s-card-link:hover .s-card.has-link {
  background-color: #16a34a;
  box-shadow: 0 24px 45px rgba(22, 163, 74, 0.35);
}
.s-card-link:hover .s-card.has-link h3,
.s-card-link:hover .s-card.has-link p { color: #fff; }
.s-card-link:hover .s-card.has-link .s-link-badge {
  background: #fff;
  color: #16a34a;
}

@media (max-width: 1024px) {
  .s-grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .s-grid { grid-template-columns: 1fr; }
}

/* Animations */
.animate-slide-up { opacity: 0; transform: translateY(40px); animation: slideUp 0.8s forwards; }
.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }
.delay-3 { animation-delay: 0.6s; }

@keyframes slideUp { to { opacity: 1; transform: translateY(0); } }

@media (max-width: 1024px) {
  .hero-content h1 { font-size: 50px; }
  .competency-grid { grid-template-columns: 1fr; }
}
</style>